import React, { useEffect, useState } from 'react';
import './BlogDash.css';
import BlogList from './BlogList';
import AddBlogForm from './AddBlogForm';
import { useAdminContext } from '../../context/AdminContext';

const BlogDash = () => {
  const [showAddBlog, setShowAddBlog] = useState(false);
  const [reloadBlogsTrigger, setReloadBlogsTrigger] = useState(0);
  const [blogs, setBlogs] = useState([]);

  const { fetchBlogs } = useAdminContext();

  useEffect(() => {
    const loadBlogs = async () => {
      try {
        const all = await fetchBlogs();
        setBlogs(all);
      } catch (err) {
        console.error('Failed to load blogs:', err);
      }
    };

    loadBlogs();
  }, [fetchBlogs, reloadBlogsTrigger]);

  const refreshBlogs = async () => {
    const all = await fetchBlogs();
    setBlogs(all);
  };

  return (
    <div className="blog-dash">
      <div className="blog-dash-actions">
        <button className="add-blog-btn" onClick={() => setShowAddBlog(true)}>Add Blog</button>
      </div>

      <div className="blog-list">
        <BlogList blogs={blogs} count="all" main={true} onRefresh={refreshBlogs} />
      </div>

      {showAddBlog && (
        <AddBlogForm
          onClose={() => setShowAddBlog(false)}
          onSuccess={() => setReloadBlogsTrigger(prev => prev + 1)}
        />
      )}
    </div>
  );
};

export default BlogDash;
